import { FormFieldTypes } from "../../../data/formFieldType";

export const corporateMembersFormData = {
    name: "corporateMembers",
    initialState: {
        SearchByCompanyNameUEN: null,
        FilterByMembershipType: null,
        FilterByStatus: null,
        organisationCategoryId:null
    },
    formFields: [
        {
            id: "SearchByCompanyNameUEN",
            lable: "Company Name/UEN",
            Field_Name: "Company Name/UEN",
            fieldType: FormFieldTypes.INPUT,
            dataField: "SearchByCompanyNameUEN",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3",
            },
        },
        {
            id: "FilterByMembershipType",
            lable: "Membership Type",
            Field_Name: "Membership Type",
            fieldType: FormFieldTypes.SELECT,
            dataField: "FilterByMembershipType",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3"
            }
        },
        {
            id: "FilterByStatus",
            lable: "Status",
            Field_Name: "Status",
            fieldType: FormFieldTypes.SELECT,
            dataField: "FilterByStatus",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-4 col-sm-12 col-12"
            }
        },
        {
            id: "organisationCategoryId",
            lable: "Organisation Category",
            Field_Name: "Organisation Category",
            fieldType: FormFieldTypes.SELECT,
            dataField: "organisationCategoryId",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            style: {
                containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3"
            }
        },

    ],
    formSetting: {
        isViewOnly: false
    }
}